<template>
  <div>
    <div class="md-layout md-gutter mb-0">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Business name</p>
        <span class="md-subheading">{{ enterprise.name }}</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">E-mail</p>
        <span class="md-subheading">{{ enterprise.email || '(not specified)' }}</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Plan</p>
        <span class="md-subheading" v-text="enterprise.owner.kindName"></span>
      </div>
    </div>
    <div class="md-layout md-gutter mb-0">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Subscription type</p>
        <span class="md-subheading" v-if="enterprise.payg == true">Metered</span>
        <span
          class="md-subheading"
          v-if="enterprise.payg == false || enterprise.payg == null"
        >Standard</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Stripe Customer ID</p>
        <CustomerText v-bind:customer="enterprise.billingCustomer" />
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Stripe Subscription ID</p>
        <SubscriptionText v-bind:subscription="enterprise.stripeSubscription" />
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">PleaseSign cycle start</p>
        <span class="md-subheading" v-if="!enterprise.subscriptionStartDiffers()">
          {{ enterprise.owner.periodStart | dateFilter }}
        </span>
        <div class="md-subheading warning" v-if="enterprise.subscriptionStartDiffers()">
          {{ enterprise.owner.periodStart | dateFilter }}
          <md-icon class="md-size-xs">info</md-icon>
          <md-tooltip>{{ $t('tooltips.enterprise.periodStartDiffers') }}</md-tooltip>
        </div>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">PleaseSign cycle end</p>
        <span class="md-subheading" v-if="!enterprise.subscriptionEndDiffers()">
          {{ enterprise.owner.currentPeriodEnd | dateFilter }}
        </span>
        <div class="md-subheading warning" v-if="enterprise.subscriptionEndDiffers()">
          {{ enterprise.owner.currentPeriodEnd | dateFilter }}
          <md-icon class="md-size-xs">info</md-icon>
          <md-tooltip>{{ $t('tooltips.enterprise.periodEndDiffers') }}</md-tooltip>
        </div>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Pay as you go?</p>
        <span class="md-subheading" v-if="!enterprise.paygIncorrect">
          {{ enterprise.payg | yesno }}
        </span>
        <div class="md-subheading warning" v-if="enterprise.paygIncorrect">
          {{ enterprise.payg | yesno }}
          <md-icon class="md-size-xs">info</md-icon>
          <md-tooltip>{{ $t('tooltips.enterprise.paygIncorrect') }}</md-tooltip>
        </div>
      </div>
    </div>
    <div class="md-layout mt-1">
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Trial complete date</p>
          <span class="md-subheading"
            v-text="trialCompleteDate">
          </span>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Subscription Interval
            <span class="md-subheading ">
              <md-icon class="md-size-xs">info</md-icon>
              <md-tooltip>{{ $t('tooltips.enterprise.subscriptionInterval') }}</md-tooltip>
            </span>
          </p>
          <span class="md-subheading" v-if="enterprise.owner.subscriptionInterval">
            {{ enterprise.owner.subscriptionInterval }}
          </span>
          <span class="md-subheading" v-else>
            (not set)
          </span>
        </div>
      </div>
    </div>

    <div class="md-layout mt-1">
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Last Year Quota Renewed Date
            <span class="md-subheading ">
              <md-icon class="md-size-xs">info</md-icon>
              <md-tooltip>{{ $t('tooltips.enterprise.quotaRenewedOnDate') }}</md-tooltip>
            </span>
          </p>
          <span class="md-subheading"
            v-text="quotaRenewedOnDate">
          </span>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Annual Plan Billed Monthly
            <span class="md-subheading ">
              <md-icon class="md-size-xs">info</md-icon>
              <md-tooltip>{{ $t('tooltips.enterprise.annualCommitmentMonthlyBilling')}}</md-tooltip>
            </span>
          </p>
          <span class="md-subheading" v-if="enterprise.owner.annualCommitmentMonthlyBilling == true"
          >Yes</span>
          <span
            class="md-subheading"
            v-if="enterprise.owner.annualCommitmentMonthlyBilling == false
            || enterprise.payg == null"
          >No</span>
        </div>
      </div>
    </div>

    <div class="md-layout mt-1">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Seats</p>
        <span class="md-display-2" v-text="enterprise.seats"></span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Allocated documents
          <span class="md-subheading ">
            <md-icon class="md-size-xs">info</md-icon>
            <md-tooltip>{{ $t('tooltips.enterprise.allocatedInfo') }}</md-tooltip>
          </span>
        </p>
        <span class="md-display-2" v-text="enterprise.allocated"></span>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Document quota</p>
        <span class="md-display-2" v-text="enterprise.quota"></span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">SMS quota</p>
        <span class="md-display-2" v-text="enterprise.smsQuota"></span>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Identity Request quota</p>
        <span class="md-display-2" v-text="enterprise.identityRequestQuota"></span>
      </div>
    </div>
  </div>
</template>
<script type="ts">
import moment from 'moment';
import CustomerText from '@/components/billing/customer-text.vue';
import SubscriptionText from '@/components/billing/subscription-text.vue';

export default {
  name: 'enterprise-update-show',
  props: ['enterprise'],
  components: {
    CustomerText,
    SubscriptionText,
  },
  computed: {
    trialCompleteDate() {
      return moment(this.enterprise.owner.trialComplete).format('DD/MM/YYYY HH:mm:ss');
    },
    quotaRenewedOnDate() {
      return moment(this.enterprise.owner.quotaRenewedOn).format('DD/MM/YYYY HH:mm:ss');
    },
  },
  filters: {
    dateFilter(input) {
      if (!input) return '';

      return moment(input).format('DD/MM/YYYY HH:mm:ss');
    },
    yesno(input) {
      if (input === true) return 'Yes';

      return 'No';
    },
  },
  methods: {
    getCustomerUrl(customerId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },

    getSubscriptionUrl(subscriptionId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].subscription(subscriptionId);
    },
  },
};
</script>
